import React from 'react';
import { useSelector } from 'react-redux';
import {checkIfQuestionAnswerUpdateRequiresARAGApproval} from "../../helpers/approvalSettings/functions";
import { downLoadFile } from "../../helpers/functions";
import { INPUT_TYPE } from "../../helpers/formGroupVariants";
import SharedApplicationFormQuestions from './sharedApplicationFormQuestions';
import { checkIfQuestionHasPendingChanges, checkIfQuestionsHasBeenModified } from '../../helpers/questions/functions';
import useAmountField from '../../hooks/useAmountField';
import { shouldShowPigLockTooltip } from '../../helpers/pigLock';

const ApplicationQuestion = (props) => {
    const {
        question,
        formData,
        handleSelectChange,
        handleTextInputChange,
        handleDateChange,
        textAreaRows,
        onDrop,
        fileDisabled,
        application,
        removeMedicalExpertFeesTableRow,
        isPlain,
        medExpertFees,
        updateMedicalExpertFees,
        handleMedicalFeesTableRows,
        extraOpponents,
        updateExtraOpponents,
        onOpponentAdd,
        opponentQuestions,
        openHistoryModal,
        openEditQuestionAnswerModal,
        mapEditingQuestionOrFieldToEditingSetting,
        checkIfQuestionIsEditable,
        approvalOptions,
        attachments,
        onAttachmentRequest,
        onClickActionLink,
        isLabelClickable,
        isEditModalOpen,
        questions,
        breachCausationCp,
        openDeleteAnswerModal,
        isApplicationTab,
    } = props;

    const { error: amountError, validate: amountValidate, onBlur: amountOnBlur } = useAmountField({
        name: question.id,
        value: formData[question.id],
        minimum: question.minimumValue,
        onChange: handleTextInputChange,
        enabled: question.inputType === INPUT_TYPE.AMOUNT,
    });
    const userRoles = useSelector(state => state.user.loggedInUser.roles);
    const selectedApplication = useSelector(state => state.newApplication.selectedApplication);


    const getApprovalSettings = (question) => {
        const changesRequiresARAGApproval =
            isPlain && checkIfQuestionAnswerUpdateRequiresARAGApproval(
                mapEditingQuestionOrFieldToEditingSetting(question),
                approvalOptions,
                userRoles
            ) ? "edit-icon--orange" : null;

        const editingSetting = 
            isPlain ? mapEditingQuestionOrFieldToEditingSetting(question) : null;

        return { changesRequiresARAGApproval, editingSetting };
    };

    const handleEditRowClick = (expertFeeId) => {
        openEditQuestionAnswerModal({
            questionAnswerForEdit: question,
            questionAnswer: formData[question.id],
            questionAnswerMedicalExpertFees: [medExpertFees.find(i => i.id === expertFeeId)]
        });
    };

    const checkIfPlainEditable = (question, section = null) => {
        return isPlain && checkIfQuestionIsEditable(
            question,
            null,
            section
        );
    };

    const validateAmountTypeQuestion = (_, val) => amountValidate(val);
    const handleBlur = amountOnBlur;

    // WI 95280: locked questions render a tooltip in the inline slot instead of an edit icon, so the slot
    // must stay alive even though checkIfPlainEditable is now false for them. Matched to the same condition
    // QuestionEditActions uses, so the slot only opens where a tooltip will actually be rendered - a locked
    // question with no editing setting of its own never had an icon and must not gain an empty slot.
    const hasInlineElements = checkIfPlainEditable(question, question.machineName)
        || checkIfQuestionHasPendingChanges(question.id, application)
        || shouldShowPigLockTooltip(
            question.machineName,
            selectedApplication,
            isPlain ? mapEditingQuestionOrFieldToEditingSetting(question) : null);

    return (
        <SharedApplicationFormQuestions
            question={question}
            formData={formData}
            isPlain={isPlain}
            value={formData[question.id]}
            application={application}
            questions={questions}
            attachments={attachments}
            openEditQuestionAnswerModal={openEditQuestionAnswerModal}
            openHistoryModal={openHistoryModal}
            isAnswerEditModalOpen={isEditModalOpen}
            isLabelClickable={isLabelClickable}
            hasInlineElements={hasInlineElements}
            dateHandler={handleDateChange}
            textHandler={handleTextInputChange}
            selectHandler={handleSelectChange}
            onDrop={onDrop}
            handleBlur={handleBlur}
            medicalExpertFees={medExpertFees}
            breachCausationCp={breachCausationCp}
            handleMedicalFeesTableRows={handleMedicalFeesTableRows}
            handleEditRowClick={handleEditRowClick}
            removeMedicalExpertFeesTableRow={removeMedicalExpertFeesTableRow}
            medicalFeesTableHandler={updateMedicalExpertFees}
            downLoadFile={downLoadFile}
            onAttachmentRequest={onAttachmentRequest}
            fileDisabled={fileDisabled}
            validateAmountTypeQuestion={validateAmountTypeQuestion}
            questionValidation={{ [question.id]: amountError }}
            textAreaRows={textAreaRows}
            mapEditingQuestionOrFieldToEditingSetting={mapEditingQuestionOrFieldToEditingSetting}
            approvalOptions={approvalOptions}
            getApprovalSettings={getApprovalSettings}
            checkIfPlainEditable={checkIfPlainEditable}
            checkIfQuestionHasPendingChanges={checkIfQuestionHasPendingChanges}
            checkIfQuestionsHasBeenModified={checkIfQuestionsHasBeenModified}
            checkIfQuestionIsEditable={checkIfQuestionIsEditable}
            openDeleteAnswerModal={openDeleteAnswerModal}
            opponents={extraOpponents}
            opponentHandler={updateExtraOpponents}
            onOpponentAdd={onOpponentAdd}
            opponentQuestions={opponentQuestions}
            onClickActionLink={onClickActionLink}
            isApplicationTab={isApplicationTab}
        />
    );
};

export default ApplicationQuestion;